import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { BRAND, CATEGORIES } from "@/lib/data";
import logo from "@/lib/images/Desi Masala Hub Vintage Seal Logo(1).png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1F1410] text-[#E6DDC9] mt-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img
              src={logo}
              alt="Desi Masala Hub"
              className="h-24 w-auto object-contain"
            />
          </div>
          <p className="text-sm text-[#C9BCA0] leading-relaxed">
            Premium Indian spices wholesale supplier and exporter, a brand of Kirti Trading. Serving restaurants,
            retailers, FMCG brands and importers across India and the world.
          </p>
          <div className="flex gap-3 mt-6">
            {[
              { Icon: Facebook, href: BRAND.social.facebook, name: "facebook" },
              { Icon: Instagram, href: BRAND.social.instagram, name: "instagram" },
              { Icon: Linkedin, href: BRAND.social.linkedin, name: "linkedin" },
              { Icon: Twitter, href: BRAND.social.twitter, name: "twitter" },
            ].map(({ Icon, href, name }) => (
              <a
                key={name}
                href={href}
                data-testid={`footer-social-${name}`}
                aria-label={name}
                className="w-9 h-9 rounded-full border border-[#E5A52A]/30 flex items-center justify-center hover:bg-[#C38B2A] hover:border-[#C38B2A] hover:text-white transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-[#E5A52A] font-semibold mb-5">Quick Links</div>
          <ul className="space-y-3 text-sm">
            {[
              { name: "Home", to: "/" },
              { name: "About", to: "/about" },
              { name: "Products", to: "/whole-spices" },
              { name: "Export", to: "/export" },
              { name: "Contact", to: "/contact" },
            ].map((l) => (
              <li key={l.name}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.name.toLowerCase()}`}
                  className="text-[#C9BCA0] hover:text-[#E5A52A] transition-colors"
                >
                  {l.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Categories */}
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-[#E5A52A] font-semibold mb-5">Categories</div>
          <ul className="space-y-3 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/${c.slug}`}
                  data-testid={`footer-cat-${c.slug}`}
                  className="text-[#C9BCA0] hover:text-[#E5A52A] transition-colors"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-[#E5A52A] font-semibold mb-5">Contact</div>
          <ul className="space-y-4 text-sm text-[#C9BCA0]">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 mt-1 text-[#E5A52A] shrink-0" />
              <span>{BRAND.address}</span>
            </li>
            <li className="flex gap-3 items-center">
              <Phone className="w-4 h-4 text-[#E5A52A] shrink-0" />
              <a href={`tel:${BRAND.phone}`} className="hover:text-[#E5A52A]" data-testid="footer-phone">
                {BRAND.phone}
              </a>
            </li>
            <li className="flex gap-3 items-center">
              <Mail className="w-4 h-4 text-[#E5A52A] shrink-0" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-[#E5A52A]" data-testid="footer-email">
                {BRAND.email}
              </a>
            </li>
          </ul>

          <div className="mt-6 aspect-[4/3] overflow-hidden rounded-sm border border-[#E5A52A]/20">
            <iframe
              title="Location"
              src={BRAND.mapEmbed}
              className="w-full h-full grayscale-[0.2]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="footer-map"
            />
          </div>
        </div>
      </div>

      <div className="border-t border-[#E5A52A]/15">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#C9BCA0]">
          <div>© {new Date().getFullYear()} Desi Masala Hub · A Brand of Kirti Trading. All rights reserved.</div>
          <div className="flex gap-6">
            <span>Wholesale Supplier · Exporter</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
